<template>
  <div class="container-moreinfo">
    <div class="vx-row">
      <vs-tabs
        alignment="fixed"
        v-model="activeTab"
        class="tab-action-btn-fill-conatiner"
      >
        <vs-tab :label="$t('customers.label.payments')">
          <div class="pt-3">
            <vs-table
              :max-items="5"
              pagination
              :data="paymentDataList"
              search
              @selected="handelSelected"
            >
              <template slot="header">
                <div class="mr-md-2 mb-1 order-1">
                  <v-select
                    label="mCodeValue"
                    v-model="dateFilter"
                    :options="['week', 'month', 'custom']"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-100 w-full"
                  />
                </div>
                <div class="mr-md-2 mb-1 order-1">
                  <v-select
                    label="mCodeValue"
                    v-model="categoryFilter"
                    :options="categoryOption"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-100 w-full"
                  />
                </div>
                <div class="mr-md-2 mb-1 order-1">
                  <vs-button @click="handleMakePayment">{{
                    $t("customers.label.make_payment")
                  }}</vs-button>
                </div>
              </template>
              <template slot="thead">
                <!-- <vs-th>{{ $t("customers.label.user_name") }}</vs-th> -->
                <vs-th>{{ $t("customers.label.transaction_id") }}</vs-th>
                <vs-th>{{ $t("customers.label.transaction_date") }}</vs-th>
                <vs-th>{{ $t("customers.label.transaction_type") }}</vs-th>
                <vs-th>{{ $t("customers.label.category") }}</vs-th>
                <!-- <vs-th>{{ $t("Status") }}</vs-th> -->
                <vs-th>{{ $t("Payment Amount") }}</vs-th>
                <!-- <vs-th>{{ $t("customers.label.debit_amount") }}</vs-th> -->
                <!-- <vs-th>{{ $t("customers.label.cancel_remark") }}</vs-th> -->
              </template>
              <template slot-scope="{ data }">
                <vs-tr
                  :key="index"
                  :data="transaction"
                  v-for="(transaction, index) in data"
                >
                  <!-- <vs-td :data="transaction.userName">{{ transaction.userName }}</vs-td> -->
                  <vs-td :data="transaction.transactionId">{{
                    transaction.transactionId
                  }}</vs-td>
                  <vs-td :data="getDate(transaction.transDate)">{{
                    getDate(transaction.transDate)
                  }}</vs-td>
                  <vs-td :data="transaction.transactionType">{{
                    transaction.transactionType
                  }}</vs-td>
                  <vs-td :data="transaction.transactionCategory">{{
                    transaction.transactionCategory
                  }}</vs-td>
                  <!-- <vs-td :data="transaction.status">{{
                    transaction.status
                  }}</vs-td> -->
                  <vs-td :data="transaction.creditAmount">{{
                    transaction.creditAmount
                  }}</vs-td>
                  <!-- <vs-td :data="transaction.amount">{{ transaction.amount }}</vs-td> -->
                  <!-- <vs-td :data="transaction.cancelRemark">{{
            transaction.cancelRemark
          }}</vs-td> -->
                  <!-- <vs-td class="whitespace-no-wrap">
            <div class="container_img">
              <feather-icon
                title="Print Payment"
                v-if="transaction.transactionType == 'PAYMENT'"
                icon="DownloadCloudIcon"
                class="icon_row"
                @click="printPayment(transaction.transactionId)"
                svgClasses="w-5 h-5 stroke-current text-cloud"
              />
              <feather-icon
                v-if="transaction.transactionType !== 'PAYMENT CANCELED'"
                title="Cancel Payment"
                icon="XIcon"
                @click="openCancelPayment(transaction)"
                svgClasses="w-5 h-5 stroke-current"
                class="icon_row"
              />
            </div>
          </vs-td> -->
                </vs-tr>
              </template>
            </vs-table>
            <div class="centerx">
              <vs-popup
                classContent="popup-example"
                :title="$t('customers.label.make_payment')"
                :active.sync="makePaymentPopup"
                class="popup-close"
              >
                <ValidationObserver ref="observer">
                  <form>
                    <div class="vx-row md:w-full lg:w-full sm:w-full mb-1 mt-1">
                      <div class="vx-col mb-2 w-full">
                        <vs-radio v-model="paymentMode" vs-value="account" class="mr-8">{{
                          $t("customers.label.account")
                        }}</vs-radio>
                        <vs-radio v-model="paymentMode" vs-value="invoice" class="mr-8">{{
                          $t("customers.label.invoice")
                        }}</vs-radio>
                        <!-- <vs-radio v-model="paymentMode" vs-value="deposit">{{
                          $t("customers.label.deposit")
                        }}</vs-radio> -->
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col sm:w-1/2 w-full">
                        <div class="dropdown-with-label">
                          <small class="date-label"
                            >{{ $t("customers.label.payment_date")
                            }}<span class="required"> *</span></small
                          >
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="payment date"
                            :key="resetKey"
                          >
                            <datepicker
                              name="start-date"
                              class="mb-2"
                              v-model="payment.paymentDate"
                            ></datepicker>
                            <span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="vx-col sm:w-1/2 w-full">
                        <div class="dropdown-with-label">
                          <small class="date-label"
                            >{{ $t("customers.label.payment_type")
                            }}<span class="required"> *</span></small
                          >
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="payment type"
                            :key="resetKey"
                          >
                            <v-select
                              label="mCodeValue"
                              v-model="payment.paymentType"
                              :options="templateData.data"
                              :placeholder="$t('placeholder.label.SelectOne')"
                              @input="checkCheque(payment.paymentType)"
                              :reduce="(mCodeValue) => mCodeValue.id"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                              class="min-w-200 w-full mb-2"
                            />
                            <span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="vx-col sm:w-1/2 mb-2 w-full">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="amount"
                          :key="resetKey"
                        >
                          <vs-input
                            :label="$t('customers.label.amount')"
                            class="w-full starlabel mb-2 font-semibold"
                            v-model="payment.amountPaid"
                            icon-no-border
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="vx-col sm:w-1/2 mb-2 w-full">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="receipt no"
                          :key="resetKey"
                        >
                          <vs-input
                            :label="$t('customers.label.receipt_no')"
                            type="text"
                            class="w-full font-semibold mb-2 starlabel"
                            v-model="payment.receiptNo"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>

                    <div class="vx-row" v-if="payment.isChequeSelected">
                      <div class="vx-col sm:w-1/2 w-full">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="cheque no"
                          :key="resetKey"
                        >
                          <vs-input
                            :label="$t('customers.label.cheque_no')"
                            type="text"
                            class="w-full font-semibold mb-2 starlabel"
                            v-model="payment.chequeNo"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="vx-col sm:w-1/2 w-full">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="bank name"
                          :key="resetKey"
                        >
                          <vs-input
                            :label="$t('customers.label.bank_name')"
                            type="text"
                            class="w-full font-semibold mb-2 starlabel"
                            v-model="payment.bankName"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div style="height: 20px" v-if="payment.isChequeSelected"></div>
                    <div class="vx-row" v-if="payment.isChequeSelected">
                      <div class="vx-col sm:w-1/2 w-full">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="branch name"
                          :key="resetKey"
                        >
                          <vs-input
                            :label="$t('customers.label.branch_name')"
                            type="text"
                            class="w-full font-semibold mb-2 starlabel"
                            v-model="payment.branchName"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="vx-col sm:w-1/2 w-full">
                        <div class="dropdown-with-label">
                          <small class="date-label"
                            >{{ $t("customers.label.cheque_date")
                            }}<span class="required"> *</span></small
                          >
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="cheque date"
                            :key="resetKey"
                          >
                            <datepicker
                              name="start-date"
                              class="mb-2"
                              v-model="payment.chequeDate"
                            ></datepicker
                            ><span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col mb-2 w-full">
                        <small class="date-label font-semibold">{{
                          $t("customers.label.notes")
                        }}</small>
                        <vs-textarea v-model="payment.remarks" />
                      </div>
                    </div>
                    <vs-checkbox
                      v-if="paymentMode == 'invoice'"
                      v-model="showInvoice"
                      class="mb-3"
                      >Show Invoice Details</vs-checkbox
                    >
                    <div class="vx-row" v-if="showInvoice && paymentMode == 'invoice'">
                      <vs-table
                        v-if="paymentMode == 'invoice'"
                        class="w-full p-2"
                        :data="billMasterList"
                        multiple
                        v-model="selectedInovice"
                      >
                        <template slot="thead">
                          <vs-th>{{ $t("customers.label.invoice_id") }}</vs-th>
                          <vs-th>{{ $t("customers.label.invoice_date") }}</vs-th>
                          <vs-th>{{ $t("customers.label.invoice_amount") }}</vs-th>
                          <vs-th>{{ $t("customers.label.due_amount") }}</vs-th>
                        </template>
                        <template slot-scope="{ data }">
                          <vs-tr
                            :key="index"
                            :data="transaction"
                            v-for="(transaction, index) in data"
                            v-if="transaction.dueAmount > 0"
                          >
                            <vs-td :data="transaction.id">{{ transaction.id }}</vs-td>
                            <vs-td :data="transaction.billDate">{{
                              transaction.billDate
                            }}</vs-td>
                            <vs-td :data="transaction.amount">{{
                              transaction.amount
                            }}</vs-td>
                            <vs-td :data="transaction.dueAmount">{{
                              transaction.dueAmount
                            }}</vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                    <vs-checkbox
                      v-if="paymentMode == 'deposit'"
                      v-model="showDeposit"
                      class="mb-3"
                      >Show Deposit Details</vs-checkbox
                    >
                    <div class="vx-row" v-if="showDeposit && paymentMode == 'deposit'">
                      <vs-table
                        class="w-full p-2"
                        :data="templateData.depositDatas"
                        v-model="selectedDeposit"
                      >
                        <template slot="thead">
                          <vs-th>{{ $t("customers.label.select") }}</vs-th>
                          <vs-th>{{ $t("customers.label.id") }}</vs-th>
                          <vs-th>{{ $t("customers.label.transaction_date") }}</vs-th>
                          <vs-th>{{ $t("customers.label.debit_amount") }}</vs-th>
                        </template>
                        <template slot-scope="{ data }">
                          <vs-tr
                            :key="index"
                            :data="transaction"
                            v-for="(transaction, index) in data"
                          >
                            <vs-td>
                              <div>
                                <vs-checkbox
                                  v-model="selectedDepositTransaction"
                                  @change="updateAmount(transaction)"
                                ></vs-checkbox>
                              </div>
                            </vs-td>
                            <vs-td>{{ transaction.id }}</vs-td>
                            <vs-td>{{ transaction.transactionDate }}</vs-td>
                            <vs-td>{{ transaction.debitAmount }}</vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                    <div class="error">
                      {{ errorMessage }}
                    </div>
                    <div class="center mt-4">
                      <span class="ml-1 mr-1">
                        <vs-button
                          @click="makePayment"
                          class="footerButton-next"
                          style="top: 0px"
                          >{{ $t("customers.label.submit") }}</vs-button
                        >
                      </span>
                    </div>
                  </form>
                </ValidationObserver>
                <validation-popup
                  :errorMessage="errorMessage"
                  :warningPopup="warningPopup"
                  :warningText="warningText"
                  @closeWarning="warningPopup = false"
                ></validation-popup>
              </vs-popup>
            </div>
            <div class="centerx">
              <vs-popup
                classContent="popup-example"
                :title="$t('customers.label.cancelPayment')"
                :active.sync="cancelRemarkPopup"
                class="popup-close mid-popup"
              >
                <form>
                  <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                    <div class="vx-col mb-2 w-full">
                      <small class="date-label font-semibold">{{
                        $t("customers.label.cancelRemark")
                      }}</small>
                      <vs-textarea v-model="cancelremark" />
                    </div>
                  </div>

                  <div class="vx-row">
                    <span class="ml-4 mr-1">
                      <vs-button type="border" @click="cancelRemarkPopup = false">{{
                        $t("customers.label.close")
                      }}</vs-button>
                    </span>
                    <span class="ml-1 mr-2">
                      <vs-button @click="paymentReversal">{{
                        $t("customers.label.confirm")
                      }}</vs-button>
                    </span>
                  </div>
                </form>
              </vs-popup>
              <vs-popup
                button-close-hidden
                :active.sync="active"
                title="Date Filter"
                class="no-header mid-popup popup-close"
              >
                <div class="vx-col mb-2 w-full">
                  <vs-radio v-model="dateFilter" vs-value="week" class="mr-8">{{
                    $t("1 Week")
                  }}</vs-radio>
                  <vs-radio v-model="dateFilter" vs-value="month" class="mr-8">{{
                    $t("1 Month")
                  }}</vs-radio>
                  <vs-radio v-model="dateFilter" vs-value="custom">{{
                    $t("Custom")
                  }}</vs-radio>
                </div>
                <div class="vx-row mb-8">
                  <div class="vx-col md:w-1/2">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("Start Date") }}<span class="required"> *</span></small
                      >
                      <datepicker
                        name="end-date"
                        :placeholder="$t('customers.label.StartDate')"
                        v-model="endDate"
                        :disabled="dateDisabled"
                      ></datepicker>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2">
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("End Date") }}<span class="required"> *</span></small
                      >
                      <datepicker
                        name="start-date"
                        :placeholder="$t('customers.label.EndDate')"
                        v-model="startDate"
                        :disabled="dateDisabled"
                      ></datepicker>
                    </div>
                  </div>
                </div>

                <div class="vx-row float-right">
                  <span class="ml-4 mr-1">
                    <vs-button type="border" @click="active = false">{{
                      $t("customers.label.Cancel")
                    }}</vs-button>
                  </span>
                  <span class="ml-1 mr-2">
                    <vs-button
                      @click="
                        getTransactions();
                        active = false;
                      "
                      >{{ $t("customers.label.Set") }}</vs-button
                    >
                  </span>
                </div>
                <div class="p-6"></div>
              </vs-popup>
            </div>
          </div>
        </vs-tab>
        <vs-tab :label="$t('customers.label.adjustment')">
          <div class="tab-text mx-2">
            <vs-table :max-items="5" pagination search :data="transactionsList">
              <template slot="header">
                <div class="mr-2 mb-1 order-1">
                  <vs-button
                    color="primary"
                    icon-pack="feather"
                    icon="icon-sliders"
                    class="truncate"
                    @click="onClickAdjustment()"
                    size="small"
                    >{{ $t("customers.label.adjustment") }}</vs-button
                  >
                </div>
              </template>
              <template slot="thead">
                <vs-th>{{ $t("customers.label.user_name") }}</vs-th>
                <vs-th>{{ $t("customers.label.id") }}</vs-th>
                <vs-th>{{ $t("customers.label.transaction_date") }}</vs-th>
                <vs-th>{{ $t("customers.label.transaction_type") }}</vs-th>
                <vs-th>{{ $t("customers.label.category") }}</vs-th>
                <vs-th>{{ $t("customers.label.credit_amount") }}</vs-th>
                <vs-th>{{ $t("customers.label.debit_amount") }}</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr
                  :key="index"
                  :data="transactions"
                  v-for="(transaction, index) in data"
                >
                  <vs-td :data="transaction.userName">{{ transaction.userName }}</vs-td>

                  <vs-td :data="transaction.transactionId">{{
                    transaction.transactionId
                  }}</vs-td>
                  <vs-td :data="getDate(transaction.transDate)">{{
                    getDate(transaction.transDate)
                  }}</vs-td>

                  <vs-td :data="transaction.transactionType">{{
                    transaction.transactionType
                  }}</vs-td>
                  <vs-td :data="transaction.transactionCategory">{{
                    transaction.transactionCategory
                  }}</vs-td>

                  <vs-td :data="transaction.creditAmount">{{
                    transaction.creditAmount
                  }}</vs-td>
                  <vs-td :data="transaction.amount">{{ transaction.amount }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-tab>
      </vs-tabs>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('customers.label.create_adjustment')"
          :active.sync="AdjustmentPopup"
          class="popup-close"
        >
          <ValidationObserver ref="observer2">
            <form>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.adjustment_date")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.adjustment_date')"
                      :key="resetKey"
                    >
                      <datepicker
                        :placeholder="$t('customers.label.SelectDate')"
                        v-model="adjustments.date"
                        class="mb-2 font-semibold"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.adjustment_code")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.adjustment_code')"
                      :key="resetKey"
                    >
                      <v-select
                        label="adjustmentCode"
                        v-model="adjustments.adjustmentCode"
                        :options="adjustmentDatas.data"
                        :placeholder="$t('placeholder.label.SelectOne')"
                        :reduce="(adjustmentCode) => adjustmentCode.id"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.adjustment_amount')"
                    :key="resetKey"
                  >
                    <vs-input
                      :label="$t('customers.label.adjustment_amount')"
                      type="text"
                      class="w-full font-semibold mb-2 starlabel"
                      v-model="adjustments.adjustmentAmount"
                    />
                    <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.adjustment_type")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.adjustment_type')"
                      :key="resetKey"
                    >
                      <v-select
                        label="discountType"
                        :options="adjustmentDatas.discountOptions"
                        :placeholder="$t('placeholder.label.SelectOne')"
                        v-model="adjustments.discount"
                        :reduce="(discountType) => discountType.discountType"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-1/2">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.notes")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.notes')"
                      :key="resetKey"
                    >
                      <vs-textarea class="w-full mb-2" v-model="adjustments.notes" />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div style="height: 20px"></div>
              <div class="center">
                <span class="ml-1 mr-1">
                  <vs-button
                    @click="addAdjustment"
                    class="footerButton-next"
                    style="top: 0px"
                    >{{ $t("customers.label.submit") }}</vs-button
                  >
                </span>
              </div>
              <div style="height: 40px"></div>
            </form>
          </ValidationObserver>
          <validation-popup
            :errorMessage="errorMessage"
            :warningPopup="warningPopup"
            :warningText="warningText"
            @closeWarning="warningPopup = false"
          ></validation-popup>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import moment from "moment";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { BUCKET_BASE_URL } from "@/http/index";

const paymentEmpty = {
  collectionby: "",
  paymentDate: moment().format("DD MMMM YYYY"),
  paymentType: "",
  amountPaid: "",
  receiptNo: "",
  isWallet: false,
  isChequeSelected: false,
  bankName: "",
  branchName: "",
  chequeNo: "",
  chequeDate: moment().format("DD MMMM YYYY"),
  notes: "",
  collectionId: "",
  collectionName: "",
  remarks: "",
};
const adjustmentObj = {
  date: moment().format("DD MMMM YYYY"),
  adjustmentCode: "",
  discount: "",
  notes: "",
  adjustmentAmount: "",
};
export default {
  props: ["clientId"],
  data() {
    return {
      activeTab: 0,
      adjustments: { ...adjustmentObj },
      AdjustmentPopup: false,
      resetKey: 0,
      startDate: moment().subtract(0, "d").format("DD MMMM YYYY"),
      endDate: moment().subtract(7, "d").format("DD MMMM YYYY"),
      makePaymentPopup: false,
      cancelRemarkPopup: false,
      cancelremark: "",
      selectedDepositTransaction: false,
      depositData: [],
      transactionId: "",
      activityLog: [
        {
          c_id: "",
          transaction_date: "",
          transaction_type: "",
          History: "",
        },
      ],
      paymentMode: "account",
      payment: {
        ...paymentEmpty,
      },
      selectedInovice: [],
      selectedDeposit: [],
      showInvoice: false,
      showDeposit: true,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      active: false,
      dateFilter: "week",
      dateDisabled: true,
      categoryOption: [],
      categoryFilter: null,
    };
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      templateData: (state) => state.customerPayment.templateDataList,
      inoviceList: (state) => state.customerPayment.inoviceList,
      transactions: (state) => state.customerAccount.transactionDetails,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    billMasterList() {
      return this.$store.getters["customerAccount/getBillMasterData"];
    },
    transactionsList() {
      return this.$store.getters["customerAccount/getTransactionDetails"];
    },
    adjustmentDatas() {
      return this.$store.getters["entity/getAdjustmentsTemplate"];
    },
    paymentDataList() {
      if (!this.categoryFilter) {
        return this.transactions;
      }
      return this.transactions.filter(
        (transaction) => transaction.transactionCategory === this.categoryFilter
      );
    },
  },
  methods: {
    async addAdjustment() {
      const isValid = await this.$refs.observer2.validate();
      if (!isValid) return;
      try {
        const adjustmentData = {
          adjustment_type: this.adjustments.discount,
          withtax: false,
          amount_paid: this.adjustments.adjustmentAmount,
          adjustment_code: this.adjustments.adjustmentCode,
          Remarks: this.adjustments.notes,
          locale: "en",
          dateFormat: "dd MMMM yyyy",
          adjustment_date: this.adjustments.date,
          billpoId: null,
        };
        await this.$store.dispatch("customer/createAdjustmentAction", {
          id: this.clientId,
          data: adjustmentData,
        });
        this.AdjustmentPopup = false;
        this.getTransactions("ADJUSTMENT");
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Adjustment Created Successfully!",
          type: "success",
        });
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    getDate(date) {
      return moment(date, "YYYY-MM-DD").format(this.formattedDate);
    },
    async getTransactions(type) {
      const params = {
        fromDate: moment(this.endDate).format("DD-MM-YYYY"),
        toDate: moment(this.startDate).format("DD-MM-YYYY"),
        type: type,
      };
      try {
        await this.$store.dispatch("customerAccount/setTransactionDetails", {
          params: params,
          clientId: this.clientId,
        });
        this.categoryOption = [
          ...new Set(
            this.transactions.map((transaction) => transaction.transactionCategory)
          ),
        ];
      } catch (e) {
        console.log("Something went wrong while retrieving transactions details: ", e);
      }
    },
    async paymentsTemplate() {
      try {
        // await this.$store.dispatch("entity/setPaymentsTemplate");
        // await this.$store.dispatch(
        //   "customerPayment/setInoviceList",
        //   this.clientId
        // );
        this.$store.dispatch("customerAccount/setBillMasterData", this.clientId);
        await this.$store.dispatch(
          "customerPayment/getListTemplateAction",
          this.clientId
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async openCancelPayment(item) {
      this.cancelRemarkPopup = true;
      this.transactionId = item.transactionId;
    },
    async paymentReversal() {
      try {
        const cancelRemarkObj = {
          cancelRemark: this.cancelremark,
          clientPoId: 0,
        };
        await this.$store.dispatch("customerPayment/cancelPaymentAction", {
          id: this.transactionId,
          data: cancelRemarkObj,
        });

        this.cancelremark = "";
        this.cancelRemarkPopup = false;
        this.$emit("refreshPage");
        this.getTransactions();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Payment Reversal Successful!",
          type: "success",
        });
      } catch (e) {
        console.log("Something went wrong while retrieving payment cancel: ", e);
      }
    },
    checkCheque(id) {
      for (let temp of this.templateData.data) {
        if (temp.id == id) {
          if (temp.mCodeValue === "Cheque") {
            this.payment.isChequeSelected = true;
          } else this.payment.isChequeSelected = false;
        }
      }
    },
    handleMakePayment() {
      this.resetKey++;
      this.makePaymentPopup = true;
    },
    updateAmount(transaction) {
      if (this.selectedDepositTransaction) {
        this.payment.amountPaid = transaction.debitAmount;
      } else {
        this.payment.amountPaid = "";
      }
    },
    async makePayment() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      if (
        this.paymentMode == "invoice" &&
        (!this.selectedInovice.length ||
          this.selectedInovice[0].amount > this.payment.amountPaid)
      ) {
        console.log("this.selectedInovice", this.selectedInovice);
        this.errorMessage =
          "Select an Invoice and make sure amount is greater or equal to invoice amount";
        this.warningPopup = true;
      } else {
        try {
          if (this.paymentMode == "account") {
            const paymentsObj = {
              paymentCode: this.payment.paymentType,
              amountPaid: this.payment.amountPaid,
              receiptNo: this.payment.receiptNo,
              remarks: this.payment.remarks,
              locale: "en",
              dateFormat: "dd MMMM yyyy",
              paymentDate: this.payment.paymentDate,
              isSubscriptionPayment: false,
            };
            if (this.payment.isChequeSelected) {
              paymentsObj.isChequeSelected = true;
              paymentsObj.chequeNo = this.payment.chequeNo;
              paymentsObj.bankName = this.payment.bankName;
              paymentsObj.branchName = this.payment.branchName;
            }
            await this.$store.dispatch("customerPayment/makePaymentAction", {
              id: this.clientId,
              data: paymentsObj,
            });
            this.$swal({
              title: "Success",
              icon: "success",
              text: "Payment Done Successfully!",
              type: "success",
            });
          } else if (this.paymentMode == "invoice") {
            const paymentsObj = {
              paymentCode: this.payment.paymentType,
              amountPaid: this.payment.amountPaid,
              receiptNo: this.payment.receiptNo,
              remarks: this.payment.remarks,
              locale: "en",
              dateFormat: "dd MMMM yyyy",
              invoiceId: this.selectedInovice[0].id,
              paymentDate: this.payment.paymentDate,
              isSubscriptionPayment: false,
            };
            if (this.payment.isChequeSelected) {
              paymentsObj.isChequeSelected = true;
              paymentsObj.chequeNo = this.payment.chequeNo;
              paymentsObj.bankName = this.payment.bankName;
              paymentsObj.branchName = this.payment.branchName;
            }
            let resp = await this.$store.dispatch("customerPayment/makePaymentAction", {
              id: this.clientId,
              data: paymentsObj,
            });
            let amount = this.payment.amountPaid;
            let creditdistributions = [];

            for (let temp of this.selectedInovice) {
              if (amount >= temp.amount) {
                creditdistributions = [
                  ...creditdistributions,
                  {
                    amount: temp.amount,
                    clientId: parseInt(this.clientId),
                    invoiceId: temp.id,
                    locale: "en",
                    paymentId: resp.data.resourceId,
                  },
                ];
                amount -= temp.amount;
              }
            }
            if (creditdistributions.length) {
              let payload = {
                avialableAmount: amount,
                creditdistributions: creditdistributions,
                locale: "en",
                paymentId: resp.data.resourceId,
              };
              await this.$store.dispatch("customerPayment/creditDistributionAction", {
                id: this.clientId,
                data: payload,
              });
            }
            this.getTransactions();
            this.$swal({
              title: "Success",
              icon: "success",
              text: "Invoice Done Successfully!",
              type: "success",
            });
          } else if (this.paymentMode == "deposit") {
            const newDeposit = {
              depositId: this.templateData.depositDatas[0].id,
              amount: this.templateData.depositDatas[0].debitAmount,
              clientId: Number(this.clientId),
              locale: "en",
            };
            this.depositData.push(newDeposit);
            const paymentsObj = {
              paymentCode: this.payment.paymentType,
              amountPaid: this.payment.amountPaid,
              receiptNo: this.payment.receiptNo,
              remarks: this.payment.remarks,
              locale: "en",
              paymentType: "Deposit",
              deposit: this.depositData,
              dateFormat: "dd MMMM yyyy",
              paymentDate: this.payment.paymentDate,
              isSubscriptionPayment: false,
            };
            if (this.payment.isChequeSelected) {
              paymentsObj.isChequeSelected = true;
              paymentsObj.chequeNo = this.payment.chequeNo;
              paymentsObj.bankName = this.payment.bankName;
              paymentsObj.branchName = this.payment.branchName;
            }
            await this.$store.dispatch("customerPayment/makePaymentAction", {
              id: this.clientId,
              data: paymentsObj,
            });
            this.getTransactions();
            this.$swal({
              title: "Success",
              icon: "success",
              text: "Deposited Successfully!",
              type: "success",
            });
          }
          this.makePaymentPopup = false;
          setTimeout(() => {
            this.payment = { ...paymentEmpty };
          }, 1000);

          this.getTransactions();
          this.$emit("refreshPage");
        } catch (e) {
          this.errorMessage = e.message.replace("The parameter", "");
          this.warningPopup = true;
          this.errors = e.message.errors;
        }
      }
    },
    printPayment(id) {
      window.open(
        BUCKET_BASE_URL +
          "/billmaster/payment/" +
          this.clientId +
          "/" +
          id +
          "?email=false&tenantIdentifier=default"
      );
    },
    handelSelected(transaction) {
      this.$router.push({
        name: "PaymentDetails",
        params: {
          id: transaction.transactionId,
          clientId: this.clientId,
        },
      });
    },
    onClickAdjustment(){
      this.$refs.observer2.reset();
      this.adjustments = { ...adjustmentObj };
      this.AdjustmentPopup = true;
    },
    async adjustmentTemplate() {
      try {
        await this.$store.dispatch("entity/setAdjustmentsTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  watch: {
    makePaymentPopup(newValue) {
      if (newValue) {
        this.paymentsTemplate();
        this.errorMessage = "";
      }
    },
    dateFilter(val) {
      if (val == "week") {
        this.startDate = moment().subtract(0, "d").format("DD MMMM YYYY");
        this.endDate = moment().subtract(7, "d").format("DD MMMM YYYY");
        this.dateDisabled = true;
      } else if (val == "month") {
        this.startDate = moment().subtract(0, "d").format("DD MMMM YYYY");
        this.endDate = moment().subtract(30, "d").format("DD MMMM YYYY");
        this.dateDisabled = true;
      } else if (val == "custom") {
        this.dateDisabled = false;
        this.active = true;
      }
      this.getTransactions();
    },
    activeTab(newValue) {
      if (newValue === 0) this.getTransactions("PAYMENT");
      else if (newValue === 1) this.getTransactions("ADJUSTMENT");
    },
  },
  mounted() {
    this.getTransactions("PAYMENT");
    this.adjustmentTemplate();
  },
};
</script>
<style>
.no-header .vs-popup .vs-popup--header {
  background: rgba(1, 1, 1, 0) !important;
}
.vdp-datepicker__calendar {
  z-index: 10000;
}
.no-header .vs-popup .vs-popup--content {
  overflow: visible;
}
.min-w-100 {
  min-width: 10rem;
}
.error {
  color: red;
  margin: 0 1rem 1rem 1rem;
}
</style>
